/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 23/03/18
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router';
import { setShowBankStatusModal } from 'actions/setting/paymentMethod';
import styles from './styles.css';

class BankStatusModal extends Component {
  render() {
    const { handleClose, openBankStatusModal } = this.props;

    return (
      <Modal show={openBankStatusModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className={`${styles['text-left']}`}>
            Assign a bank account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You need to assign a bank account to each outlet</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className={`btn btn-default pull-left ${styles['btn-color']}`}
            onClick={() => {
              this.props.dispatch(setShowBankStatusModal(false));
            }}
          >
            Cancel
          </button>
          <Link
            className="btn btn-primary"
            to="/settings/bank_account"
            onClick={() => {
              this.props.dispatch(setShowBankStatusModal(false));
            }}
          >
            Assign bank account now
          </Link>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const { openBankStatusModal } = state.setting.paymentMethod;
  return {
    openBankStatusModal,
  };
}

export default connect(mapStateToProps)(BankStatusModal);
